import { ErrorHandler, Injectable } from '@angular/core';
import { AppInsightsService } from './lib-app-insights.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  constructor(private appInsights: AppInsightsService) {
    super();
  }

  handleError(error): void {
    // Log errors in app insights
    // 0 status code error when browser doesn't catches the response from server.
    if (error.status !== 0) {
      this.appInsights.logException(error);
    }

    // Default error logging in console
    super.handleError(error);
  }
}
